var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homeTit2Wrap"},[_c('div',{staticClass:"homeTit"},_vm._l((_vm.title),function(item,index){return _c('span',{staticClass:"tit",class:{active:_vm.tit2Active == index},on:{"click":function($event){return _vm.changeTit(index,item)}}},[_vm._v(_vm._s(item))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }